import React from "react";
import { Navigate } from "react-router-dom";
import { PagePaths } from "@shared/constants";
import { stepsAuthentication, stepsCreateAccount } from "@authien/flowConfig";
import CongratulationsPage from "@features/createaccount/page/CongratulationsPage";
import OnBoardingPage from "@features/createaccount/page/OnBoarding";
import ServiceTermsVersion1 from "@pages/ServiceTerms/Version1";
import { AuthenticationRoute, CreateAccountRoute, OnBoardingRoute, ServiceTermsRoute } from "@components/RouteWrappers";
import { FF_NATIVE_LOGIN } from "@shared/utils/feature-flag";

// Route configuration with proper wrappers
export const routeConfig = [
  // Authentication Routes
  ...stepsAuthentication.map((step) => ({
    path: step.page,
    element: (
      <AuthenticationRoute>
        {step.element}
      </AuthenticationRoute>
    ),
    stepNumber: step.stepNumber
  })),

  // Create Account Routes
  ...(FF_NATIVE_LOGIN
    ? stepsCreateAccount.map((step) => ({
        path: step.page,
        element: (
          <CreateAccountRoute>
            {step.element}
          </CreateAccountRoute>
        ),
        stepNumber: step.stepNumber
      }))
    : stepsCreateAccount.map((step) => ({
        path: step.page,
        element: <Navigate to={PagePaths.LOGIN.IDENTITY} replace />,
        stepNumber: step.stepNumber
      }))
  ),

  // Congratulations Route
  {
    path: PagePaths.SIGNUP.CONGRATULATIONS,
    element: FF_NATIVE_LOGIN
      ? (
        <CreateAccountRoute>
          <CongratulationsPage />
        </CreateAccountRoute>
      )
      : <Navigate to={PagePaths.LOGIN.IDENTITY} replace />,
    stepNumber: 'congratulations'
  },

  // OnBoarding Route
  {
    path: PagePaths.ONBOARDING,
    element: (
      <OnBoardingRoute>
        <OnBoardingPage />
      </OnBoardingRoute>
    ),
    stepNumber: 'onboarding'
  },

  // Service Terms Routes (wildcard)
  {
    path: `${PagePaths.SERVICETERMS}/*`,
    element: (
      <ServiceTermsRoute>
        <ServiceTermsVersion1 />
      </ServiceTermsRoute>
    ),
    stepNumber: 'serviceTerms'
  }
];

// Simple interface for route configuration
export interface RouteConfigItem {
  path: string;
  element: React.ReactElement;
  stepNumber: string | number;
}
